import React, { useState, useEffect, useCallback, useRef, memo } from 'react';

function PageNotFound(){
  return(
    <div className="FullWidth FullHeight FlexCenter"><div className="AutoMargin">Error 404 - Page not found.</div></div>
  )
}

export default memo(PageNotFound)